import { render } from "./TopThreeDatenblattMod.vue?vue&type=template&id=37050540&scoped=true"
import script from "./TopThreeDatenblattMod.vue?vue&type=script&lang=js"
export * from "./TopThreeDatenblattMod.vue?vue&type=script&lang=js"

import "./TopThreeDatenblattMod.vue?vue&type=style&index=0&id=37050540&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\TvBerater\\FernseherBeraterUpdate05012026\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37050540"]])

export default __exports__